import { compose } from 'recompose';
import apiInterceptor from '../../../api/interceptor';
import GRNReport from './GRNReport';
import { grnReportApi } from '../../common/base.api';

const composedGRNReport = compose(apiInterceptor({ ...grnReportApi }))(GRNReport);

export default composedGRNReport;
